import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import {
  LISTEN_TYP_INFOS,
  ListenTypInfo,
  ProjektListenTyp
} from '../../../../../Models/Sps';

export interface ListentypAuswahlDialogData {
  projektName: string;
}

/**
 * Dialog „Neue Liste hinzufügen“.
 *
 * Entscheidet nur, WELCHER Listentyp angelegt wird. Die Navigation übernimmt
 * der Aufrufer (Projekt-Detailansicht): Messstellen- und Verbraucherliste
 * führen zum bestehenden KI-Import, die beiden SPS-Typen zum SPS-Import.
 */
@Component({
  selector: 'app-listentyp-auswahl-dialog',
  templateUrl: './listentyp-auswahl-dialog.component.html',
  styleUrls: ['./listentyp-auswahl-dialog.component.css']
})
export class ListentypAuswahlDialogComponent {

  readonly typen: ListenTypInfo[] = LISTEN_TYP_INFOS;

  auswahl: ProjektListenTyp | null = null;

  constructor(
    public dialogRef: MatDialogRef<ListentypAuswahlDialogComponent, ProjektListenTyp | null>,
    @Inject(MAT_DIALOG_DATA) public data: ListentypAuswahlDialogData
  ) { }

  waehle(typ: ProjektListenTyp): void {
    this.auswahl = typ;
  }

  get gewaehlt(): ListenTypInfo | null {
    return this.typen.find(t => t.typ === this.auswahl) ?? null;
  }

  weiter(): void {
    if (this.auswahl) {
      this.dialogRef.close(this.auswahl);
    }
  }

  abbrechen(): void {
    this.dialogRef.close(null);
  }
}
